import { Container } from '@mui/material';
import React from 'react';
import About from '../About/About';
import Banner from './Banner/Banner';
import './Home.css'
import OurExperts from './OurExperts/OurExperts';
import Whyus from './Whyus/Whyus';
import { Helmet } from 'react-helmet-async';

const Home = () => {
    const faqSchema = {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": [
            {
                "@type": "Question",
                "name": "What is Den Den Claw?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Den Den Claw is a Japanese-style claw machine arcade in Ottawa, located in Chinatown. We offer skill-based claw machines, prize trade-ins, a photo booth, gachapon machines, and a year-round Artist Alley featuring local creators."
                }
            },
            {
                "@type": "Question",
                "name": "Is Den Den Claw a good place to visit in Ottawa?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Yes! Den Den Claw is a popular indoor attraction in Ottawa for locals and tourists. It's a great place to visit for arcade games, unique prizes, local art, and a fun experience for all ages."
                }
            },
            {
                "@type": "Question",
                "name": "What kind of arcade games does Den Den Claw have?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Den Den Claw specializes in claw machines with plushies, figures, anime prizes, and collectibles. We also offer gachapon capsule machines and a prize trade-in system so you can upgrade your wins."
                }
            },
            {
                "@type": "Question",
                "name": "What is Artist Alley at Den Den Claw?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Artist Alley at Den Den Claw is a convention-style artist market that is open year-round. It features local Ottawa artists selling prints, stickers, keychains, and original art - similar to what you'd find at anime and comic conventions."
                }
            },
            {
                "@type": "Question",
                "name": "Where is Den Den Claw located?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Den Den Claw is located in Ottawa's Chinatown. It's easily accessible and a popular stop for people looking for fun indoor activities in the city."
                }
            },
            {
                "@type": "Question",
                "name": "Is Den Den Claw good for dates or group outings?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Yes! Den Den Claw is a fun spot for date nights, friend hangouts, and group outings. The arcade atmosphere, prize games, and Artist Alley make it a unique experience in Ottawa."
                }
            },
            {
                "@type": "Question",
                "name": "Is Den Den Claw family-friendly?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Den Den Claw is family-friendly and suitable for all ages. Children, teens, and adults can all enjoy the claw machines, prizes, and arcade experience."
                }
            },
            {
                "@type": "Question",
                "name": "Do I need tickets or reservations to visit?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "No reservations are required to visit Den Den Claw. Walk-ins are welcome during opening hours."
                }
            }
        ]
    };
    return (
        <div id='home'>
            <Helmet>
                <title>Den Den Claw | Claw Machine Arcade & Artist Alley in Ottawa</title>
                <link rel="canonical" href="https://www.dendenclaw.com/" />
                <script type="application/ld+json">
                    {JSON.stringify(faqSchema)}
                </script>
            </Helmet>
            <Banner></Banner>
            <Whyus></Whyus>
            <OurExperts></OurExperts>
            <Container className='content-container' maxWidth="xl">
                <About></About>
            </Container>
            {/* <Box sx={{ p: 5, mb: 2, alignItems: 'center' }}>
                <Typography sx={{ textAlign: "center" }} variant="h5"> <SubscriptionsIcon sx={{ color: 'primary.main', mr: 1, my: 0.5 }} /> Subscribe for our latest services and details</Typography>

                <Box sx={{ display: { xs: 'flex-wrap', md: 'flex' }, p: 2, mt: 1, mx: 'auto', minWidth: "70%" }}>
                    <Box sx={{ display: 'flex', alignItems: 'flex-end', mb: 2, mx: 'auto', minWidth: "70%" }}>
                        <EmailIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                        <TextField fullWidth id="fullWidth" label="Enter Your Mail Address" variant="standard" />
                    </Box>
                    <Button variant="outlined" color="primary" onClick={mailSendBtn} startIcon={<SubscriptionsIcon />}>Subscribe</Button>
                </Box>
            </Box> */}
        </div>
    );
};

export default Home;
